<div class="card-body p-0"
  *ngIf="matrizPreliminar || mostrarSecaoManifestacao || mostrarSecaoDefinitiva || mostrarSecaoConsolidada || !visualizar; else content">

  <div id="accordion-matriz-constatacao">
    <div class="card p-0">
      <div class="card-header" id="heading-ug">
        <h5 class="mb-0">
          <div class="d-flex justify-content-between align-items-center">
            <button class="btn btn-link limit-text" data-toggle="collapse" data-target="#collapse-ug"
              aria-expanded="true" aria-controls="collapse-ug">
              MATRIZ DE CONSTATAÇÃO - <strong>{{ sharedService.getNomeUG() }}</strong>
            </button>
          </div>
        </h5>
      </div>

      <div id="collapse-ug" class="collapse show" aria-labelledby="heading-ug"
        data-parent="#accordion-matriz-constatacao">

        <div id="accordion-matriz-sub">

          <!-- ================= PRELIMINAR ================= -->
          <div class="card p-0">
            <div class="card-header" id="heading-preliminar">
              <h5 class="mb-0">
                <div class="d-flex justify-content-between align-items-center">
                  <button class="btn btn-link text-start" data-toggle="collapse" data-target="#collapse-preliminar"
                    aria-expanded="false" aria-controls="collapse-preliminar">
                    Matriz de Constatações <strong>Preliminar</strong>
                    <span *ngIf="matrizPreliminar" class="ml-2"
                      [ngClass]="getStatusMatrizClass(matrizPreliminar.status)">
                      {{ getStatusMatrizDescricao(matrizPreliminar.status) }}
                    </span>
                  </button>

                  <div>
                    <button class="btn btn-primary btn-sm mr-1" *ngIf="!visualizar && podePlanejar"
                      [disabled]="manifestacaoAuditado?.status === StatusManifestacaoAuditado.Enviado"
                      (click)="gerarMatrizPreliminar(); $event.stopPropagation()">
                      <i class="fas fa-plus-circle"></i> Gerar Matriz
                    </button>

                    <button class="btn btn-success btn-sm mr-1" *ngIf="!visualizar && matrizPreliminar && podeAprovar()"
                      (click)="aprovarMatrizPreliminar(); $event.stopPropagation()">
                      <i class="fas fa-check-circle"></i> Aprovar
                    </button>

                    <button class="btn btn-info btn-sm mr-1" *ngIf="matrizPreliminar && podeVisualizarMatriz"
                      (click)="visualizarImprimirMatriz('preliminar'); $event.stopPropagation()">
                      <i class="fas fa-eye"></i>
                    </button>

                    <button type="button" class="btn btn-warning btn-sm ml-1" title="Histórico"
                      (click)="verHistoricoMatriz(matrizPreliminar)">
                      <i class="fas fa-history"></i>
                    </button>

                    <button class="btn btn-warning btn-sm mr-1" *ngIf="!visualizar && podeHabilitarPT()"
                      (click)="habilitarPT(); $event.stopPropagation()">
                      <i class="fas fa-unlock"></i> Habilitar PT
                    </button>
                  </div>
                </div>
              </h5>
            </div>

            <div id="collapse-preliminar" class="collapse" aria-labelledby="heading-preliminar"
              data-parent="#accordion-matriz-sub">

              <div class="card-body p-0" *ngIf="matrizPreliminar; else semPreliminar">
                <table mat-table [dataSource]="dataSourcePreliminar" *ngIf="!semDadosPreliminar" class="w-100" matSort
                  #sortPreliminar="matSort">

                  <ng-container matColumnDef="constacao">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Constatações</th>
                    <td mat-cell *matCellDef="let item"
                      [matTooltip]="item.identificador + ' - ' + item.descricaoConstatacao" matTooltipPosition="above">
                      {{ item.identificador }} - {{ item.descricaoConstatacao }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="responsavel">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Responsável pelo Preenchimento</th>
                    <td mat-cell *matCellDef="let item">{{ item.responsavel?.nome || '-' }}</td>
                  </ng-container>

                  <ng-container matColumnDef="dataFinalizacao">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Data Finalização</th>
                    <td mat-cell *matCellDef="let item">{{ item?.dataHoraFinalizacao | date: "dd/MM/yyyy" }}</td>
                  </ng-container>

                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                    <td mat-cell *matCellDef="let item">
                      <span [ngClass]="getStatusItemClass(item.status)">
                        {{ getStatusItemDescricao(item.status) }}
                      </span>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="acoes">
                    <th mat-header-cell *matHeaderCellDef class="text-center">Ações</th>
                    <td mat-cell *matCellDef="let item">
                      <div class="w-100 d-flex justify-content-center">
                        <button class="icon-btn btn btn-info btn-xs"
                          (click)="editarItemPreliminar(item, true); $event.stopPropagation()" title="Visualizar">
                          <i class="fas fa-eye"></i>
                        </button>
                        <button class="btn btn-primary btn-xs ml-1" *ngIf="!visualizar && podeEditarItem(item)"
                          (click)="editarItemPreliminar(item, false); $event.stopPropagation()" title="Editar">
                          <i class="fas fa-pen"></i>
                        </button>
                        <!-- ✅ tipoMatriz='preliminar' → idFuncionalidade=38 -->
                        <button type="button" class="btn btn-warning btn-xs ml-1" title="Histórico"
                          (click)="verHistoricoConstatacao(item, 'preliminar'); $event.stopPropagation()">
                          <i class="fas fa-history"></i>
                        </button>
                      </div>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumnsPreliminar"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsPreliminar"
                    (click)="selecionarItemPreliminar(row)"
                    [ngClass]="{'bg-light': selectedItemPreliminar?.id === row.id}" style="cursor: pointer;">
                  </tr>
                </table>

                <h5 class="table-no-data" *ngIf="semDadosPreliminar">Nenhum registro encontrado.</h5>

                <mat-paginator #paginatorPreliminar [pageSizeOptions]="[15, 30, 50]" showFirstLastButtons>
                </mat-paginator>
              </div>

              <ng-template #semPreliminar>
                <h5 class="table-no-data p-3">Nenhuma matriz preliminar encontrada.</h5>
              </ng-template>
            </div>
          </div>

          <!-- ================= MANIFESTAÇÃO ================= -->
          <div class="card p-0"
            *ngIf="mostrarSecaoManifestacao || matrizPreliminar?.status === StatusMatrizConstatacao.Aprovada">

            <div class="card-header" id="heading-manifestacao">
              <h5 class="mb-0">
                <div class="d-flex justify-content-between align-items-center">
                  <button class="btn btn-link text-start" data-toggle="collapse" data-target="#collapse-manifestacao"
                    aria-expanded="false" aria-controls="collapse-manifestacao">
                    Manifestação do <strong>Auditado</strong>
                    <span *ngIf="manifestacaoAuditado" class="ml-2"
                      [ngClass]="getStatusClass(manifestacaoAuditado?.status)">
                      {{ getStatusManifestacaoDescricao(manifestacaoAuditado?.status) }}
                    </span>
                  </button>

                  <div class="d-flex align-items-center" *ngIf="manifestacaoAuditado">
                    <button type="button" class="btn btn-warning btn-sm" title="Histórico"
                      (click)="verHistorico(manifestacaoAuditado); $event.stopPropagation()">
                      <i class="fas fa-history"></i>
                    </button>
                  </div>
                </div>
              </h5>
            </div>

            <div id="collapse-manifestacao" class="collapse" aria-labelledby="heading-manifestacao"
              data-parent="#accordion-matriz-sub">

              <div class="card-body p-0">
                <table mat-table [dataSource]="dataSourceManifestacao"
                  *ngIf="dataSourceManifestacao?.data?.length !== 0" class="w-100" matSort matSortActive="id"
                  matSortDirection="asc">

                  <ng-container matColumnDef="nome">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome</th>
                    <td mat-cell *matCellDef="let element">Manifestação do Auditado</td>
                  </ng-container>

                  <ng-container matColumnDef="responsavel">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Responsável pelo Preenchimento</th>
                    <td mat-cell *matCellDef="let element">{{ element?.responsavel?.nome || '-' }}</td>
                  </ng-container>

                  <ng-container matColumnDef="dataFinalizacao">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Data de Finalização</th>
                    <td mat-cell *matCellDef="let element">{{ element?.dataFinalizacao | date: "dd/MM/yyyy" }}</td>
                  </ng-container>

                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                    <td mat-cell *matCellDef="let element">
                      <span [ngClass]="getStatusClass(element?.status)" class="badge text-xs">
                        {{ getStatusManifestacaoDescricao(element?.status) }}
                      </span>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="acoes">
                    <th mat-header-cell *matHeaderCellDef class="text-center">Ações</th>
                    <td mat-cell *matCellDef="let element">
                      <div class="w-100 d-flex justify-content-center">
                        <button class="icon-btn btn btn-info btn-xs" title="Visualizar"
                          (click)="editarManifestacaoAuditado(element, true); $event.stopPropagation()">
                          <i class="fas fa-eye"></i>
                        </button>
                        <button type="button" *ngIf="podeEditarManifestacao()" class="btn btn-primary btn-xs ml-1"
                          title="Editar" (click)="editarManifestacaoAuditado(element, false); $event.stopPropagation()">
                          <i class="fas fa-pen"></i>
                        </button>
                        <button type="button" *ngIf="podeAvaliarManifestacao()" class="btn btn-success btn-xs ml-1"
                          title="Aprovar" (click)="avaliarManifestacaoAuditado(element); $event.stopPropagation()">
                          <i class="fas fa-check"></i>
                        </button>
                        <button type="button" class="btn btn-warning btn-xs ml-1" title="Histórico"
                          (click)="verHistorico(element); $event.stopPropagation()">
                          <i class="fas fa-history"></i>
                        </button>
                      </div>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumnsManifestacao"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsManifestacao"></tr>
                </table>

                <h5 *ngIf="dataSourceManifestacao?.data?.length === 0" class="table-no-data">
                  Nenhum registro encontrado.
                </h5>

                <mat-paginator [pageSizeOptions]="[15, 30, 50]" showFirstLastButtons></mat-paginator>
              </div>
            </div>
          </div>

          <!-- ================= DEFINITIVA ================= -->
          <div class="card p-0" *ngIf="mostrarSecaoDefinitiva">
            <div class="card-header" id="heading-definitiva">
              <h5 class="mb-0">
                <div class="d-flex justify-content-between align-items-center">
                  <button class="btn btn-link text-start" data-toggle="collapse" data-target="#collapse-definitiva"
                    aria-expanded="false" aria-controls="collapse-definitiva">
                    MATRIZ DE CONSTATAÇÕES <strong>DEFINITIVA</strong>
                    <span *ngIf="matrizDefinitiva" class="ml-2"
                      [ngClass]="getStatusMatrizClass(matrizDefinitiva.status)">
                      {{ getStatusMatrizDescricao(matrizDefinitiva.status) }}
                    </span>
                  </button>

                  <div class="d-flex align-items-center">
                    <button class="btn btn-info btn-sm mr-1" *ngIf="matrizDefinitiva"
                      (click)="visualizarImprimirMatriz('definitiva'); $event.stopPropagation()" title="Visualizar">
                      <i class="fas fa-eye"></i>
                    </button>
                    <button class="btn btn-primary btn-sm mr-1"
                      *ngIf="!visualizar && podePlanejar && matrizDefinitiva.isOsaPrincipal"
                      (click)="gerarMatrizConsolidada(); $event.stopPropagation()">
                      <i class="fas fa-plus-circle"></i> Gerar Matriz
                    </button>
                    <button type="button" class="btn btn-warning btn-sm" title="Histórico" *ngIf="matrizDefinitiva"
                      (click)="verHistoricoMatrizDefinitiva(matrizDefinitiva); $event.stopPropagation()">
                      <i class="fas fa-history"></i>
                    </button>
                  </div>
                </div>
              </h5>
            </div>

            <div id="collapse-definitiva" class="collapse" aria-labelledby="heading-definitiva"
              data-parent="#accordion-matriz-sub">

              <div class="card-body p-0" *ngIf="matrizDefinitiva; else semDefinitiva">
                <table mat-table [dataSource]="dataSourceDefinitiva" *ngIf="!semDadosDefinitiva" class="w-100" matSort
                  #sortDefinitiva="matSort">

                  <!--                  <ng-container matColumnDef="selecao">-->
                  <!--                    <th mat-header-cell *matHeaderCellDef class="text-center"></th>-->
                  <!--                    <td mat-cell *matCellDef="let item" class="text-center">-->
                  <!--                      <input type="radio"-->
                  <!--                             [checked]="selectedConstatacaoDefinitiva?.id === item.id"-->
                  <!--                             (click)="selecionarConstatacaoDefinitivaRow(item); $event.stopPropagation()"/>-->
                  <!--                    </td>-->
                  <!--                  </ng-container>-->

                  <ng-container matColumnDef="constacao">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Constatações</th>
                    <td mat-cell *matCellDef="let item">
                      {{ item.identificador || '-' }} - {{ item.descricaoConstatacao || '-' }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="responsavel">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Responsável pelo Preenchimento</th>
                    <td mat-cell *matCellDef="let item">{{ item.responsavel?.nome || '-' }}</td>
                  </ng-container>

                  <ng-container matColumnDef="dataFinalizacao">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Data Finalização</th>
                    <td mat-cell *matCellDef="let item">
                      {{ item.dataHoraFinalizacao ? (item.dataHoraFinalizacao | date:'dd/MM/yyyy') : '-' }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                    <td mat-cell *matCellDef="let item">
                      <span [ngClass]="getStatusItemClass(item.status)">
                        {{ getStatusItemDescricao(item.status) }}
                      </span>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="acoes">
                    <th mat-header-cell *matHeaderCellDef class="text-center">Ações</th>
                    <td mat-cell *matCellDef="let item">
                      <div class="w-100 d-flex justify-content-center">
                        <button class="icon-btn btn btn-info btn-xs"
                          (click)="editarItemDefinitivo(item, true); $event.stopPropagation()" title="Visualizar">
                          <i class="fas fa-eye"></i>
                        </button>
                        <button class="btn btn-primary btn-xs ml-1"
                          *ngIf="!visualizar && podeEditarItemDefinitiva(item)"
                          (click)="editarItemDefinitivo(item, false); $event.stopPropagation()" title="Editar">
                          <i class="fas fa-pen"></i>
                        </button>
                        <button class="btn btn-danger btn-xs ml-1"
                          *ngIf="!visualizar && podeCancelarItemDefinitiva(item) && !matrizDefinitiva?.isExisteConsolidada"
                          (click)="abrirModalCancelarConstatacao(item); $event.stopPropagation()" title="Cancelar">
                          <i class="fas fa-ban"></i>
                        </button>
                        <button class="btn btn-success btn-xs ml-1"
                          *ngIf="!visualizar && podeAtivarItemDefinitiva(item) && !matrizDefinitiva?.isExisteConsolidada"
                          (click)="ativarConstatacaoDefinitiva(item); $event.stopPropagation()"
                          title="Ativar Constatação">
                          <i class="fas fa-check"></i>
                        </button>
                        <!-- ✅ tipoMatriz='definitiva' → idFuncionalidade=42 -->
                        <button type="button" class="btn btn-warning btn-xs ml-1" title="Histórico"
                          (click)="verHistoricoConstatacao(item, 'definitiva'); $event.stopPropagation()">
                          <i class="fas fa-history"></i>
                        </button>
                      </div>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumnsDefinitiva"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsDefinitiva"
                    (click)="selecionarConstatacaoDefinitivaRow(row)"
                    [ngClass]="{'bg-light': selectedConstatacaoDefinitiva?.id === row.id}" style="cursor: pointer;">
                  </tr>
                </table>

                <h5 class="table-no-data" *ngIf="semDadosDefinitiva">Nenhum registro encontrado.</h5>

                <mat-paginator #paginatorDefinitiva [pageSizeOptions]="[15, 30, 50]" showFirstLastButtons>
                </mat-paginator>

                <div class="p-3" *ngIf="!podeEditarMatrizDefinitiva()">
                  <small class="text-muted">Esta Matriz Definitiva está em modo somente leitura.</small>
                </div>
              </div>

              <ng-template #semDefinitiva>
                <h5 class="table-no-data p-3">Nenhuma matriz definitiva encontrada.</h5>
              </ng-template>
            </div>
          </div>

          <!-- ================= DEFINITIVA - CONSOLIDADA ================= -->
          <div class="card p-0" *ngIf="mostrarSecaoConsolidada">
            <div class="card-header" id="heading-consolidada">
              <h5 class="mb-0">
                <div class="d-flex justify-content-between align-items-center">
                  <button class="btn btn-link text-start" data-toggle="collapse" data-target="#collapse-consolidada"
                    aria-expanded="false" aria-controls="collapse-consolidada">
                    MATRIZ DE CONSTATAÇÕES <strong>DEFINITIVA - CONSOLIDADA</strong>
                    <span *ngIf="matrizDefinitivaConsolidada" class="ml-2"
                      [ngClass]="getStatusMatrizClass(matrizDefinitivaConsolidada.status)">
                      {{ getStatusMatrizDescricao(matrizDefinitivaConsolidada.status) }}
                    </span>
                  </button>

                  <button type="button" class="btn btn-danger btn-sm mr-1"
                    *ngIf="matrizDefinitivaConsolidada?.matrizConsolidadaId" [disabled]="visualizar"
                    (click)="excluirMatrizConsolidada(); $event.stopPropagation()" title="Excluir Matriz Consolidada">
                    <i class="fas fa-trash"></i> Excluir Matriz
                  </button>
                  <div class="d-flex align-items-center">
                    <button class="btn btn-info btn-sm mr-1" *ngIf="matrizDefinitivaConsolidada"
                      (click)="visualizarMatrizConsolidada(); $event.stopPropagation()" title="Visualizar">
                      <i class="fas fa-eye"></i>
                    </button>
                    <button type="button" class="btn btn-info btn-sm mr-1" (click)="imprimir()">
                      <i class="far fas fa-print"></i> Imprimir
                    </button>
                    <button type="button" class="btn btn-warning btn-sm" title="Histórico"
                      *ngIf="matrizDefinitivaConsolidada"
                      (click)="verHistoricoMatrizConsolidada(); $event.stopPropagation()">
                      <i class="fas fa-history"></i>
                    </button>
                  </div>
                </div>
              </h5>
            </div>

            <div id="collapse-consolidada" class="collapse" aria-labelledby="heading-consolidada"
              data-parent="#accordion-matriz-sub">

              <div class="card-body p-0">
                <div class="card p-0" *ngFor="let secao of secoesConsolidadasVM; let i = index">

                  <div class="card-header" [attr.id]="secao.headingId">
                    <h5 class="mb-0">
                      <div class="d-flex justify-content-between align-items-center">
                        <button class="btn btn-link text-start" data-toggle="collapse"
                          [attr.data-target]="'#' + secao.collapseId" aria-expanded="false"
                          [attr.aria-controls]="secao.collapseId">
                          MATRIZ DEFINITIVA - <strong>{{ secao.unidadeGestoraNome }}</strong>
                          <span class="ml-2" [ngClass]="getStatusMatrizClass(secao.statusMatrizUg)">
                            {{ getStatusMatrizDescricao(secao.statusMatrizUg) }}
                          </span>
                        </button>

                        <div class="d-flex align-items-center">
                          <button class="btn btn-info btn-sm mr-1"
                            (click)="visualizarMatrizPorId(secao.matrizDefinitivaUgId, 'definitiva',  secao.numeroOsa , secao.unidadeGestoraNome); $event.stopPropagation()"
                            title="Visualizar">
                            <i class="fas fa-eye"></i>
                          </button>
                          <button type="button" class="btn btn-warning btn-sm" title="Histórico"
                            (click)="verHistoricoMatrizPorId(secao.matrizDefinitivaUgId, 'Matriz Definitiva - ' + secao.unidadeGestoraNome, 42); $event.stopPropagation()">
                            <i class="fas fa-history"></i>
                          </button>
                        </div>
                      </div>
                    </h5>
                  </div>

                  <div class="collapse" [attr.id]="secao.collapseId" [attr.aria-labelledby]="secao.headingId">

                    <div class="card-body p-0">
                      <table mat-table [dataSource]="secao.dataSource" *ngIf="!secao.semDados" class="w-100" matSort>

                        <ng-container matColumnDef="constacao">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header>Constatações</th>
                          <td mat-cell *matCellDef="let item">
                            {{ item.identificador || '-' }} - {{ item.descricaoConstatacao || '-' }}
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="responsavel">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header>Responsável pelo Preenchimento</th>
                          <td mat-cell *matCellDef="let item">{{ item.responsavel?.nome || '-' }}</td>
                        </ng-container>

                        <ng-container matColumnDef="dataFinalizacao">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header>Data Finalização</th>
                          <td mat-cell *matCellDef="let item">
                            {{ item.dataHoraFinalizacao ? (item.dataHoraFinalizacao | date:'dd/MM/yyyy') : '-' }}
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="status">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                          <td mat-cell *matCellDef="let item">
                            <span [ngClass]="getStatusItemClass(item.status)">
                              {{ getStatusItemDescricao(item.status) }}
                            </span>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="acoes">
                          <th mat-header-cell *matHeaderCellDef class="text-center">Ações</th>
                          <td mat-cell *matCellDef="let item">
                            <div class="w-100 d-flex justify-content-center">
                              <button class="icon-btn btn btn-info btn-xs"
                                (click)="visualizarItemConsolidado(item); $event.stopPropagation()" title="Visualizar">
                                <i class="fas fa-eye"></i>
                              </button>
                              <!-- ✅ tipoMatriz='consolidada' → idFuncionalidade=42 (mesmo da Definitiva) -->
                              <button type="button" class="btn btn-warning btn-xs ml-1" title="Histórico"
                                (click)="verHistoricoConstatacao(item, 'consolidada'); $event.stopPropagation()">
                                <i class="fas fa-history"></i>
                              </button>
                            </div>
                          </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsConsolidada"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsConsolidada"></tr>
                      </table>

                      <h5 class="table-no-data p-3" *ngIf="secao.semDados">
                        Nenhuma constatação finalizada encontrada.
                      </h5>
                    </div>
                  </div>
                </div>

                <h5 class="table-no-data p-3" *ngIf="!secoesConsolidadasVM || secoesConsolidadasVM.length === 0">
                  Nenhuma seção encontrada.
                </h5>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #content>
  <h5 class="table-no-data p-3">Nenhuma Matriz de Constatações encontrada.</h5>
</ng-template>